// extracted by mini-css-extract-plugin
export default {"image-text-module":"image-text-module--CPFRg","imageTextModule":"image-text-module--CPFRg"};